//Widgets import
import React, { useContext } from 'react';
import Modal from '../../atoms/modal/view';
import ButtonHub from '../../atoms/buttonHub/view';
import ButtonBasic from '../../atoms/buttonBasic/view';
import ButtonAction from '../../atoms/buttonAction/view';
import ButtonPrimary from '../../atoms/ButtonPrimary/view';
import ButtonSecondary from '../../atoms/ButtonSecondary/view';
import { dispatchCustomEvent } from '../../../utils/dispatch';
import { ButtonGroupContext } from '../buttonGroup/context';

const BUTTON_COMPONENTS = {
    basic: ButtonBasic,
    primary: ButtonPrimary,
    secondary: ButtonSecondary,
    topbar: ButtonBasic,
    action: ButtonAction,
    hub: ButtonHub,
    'pill-primary': ButtonPrimary,
    'pill-secondary': ButtonSecondary,
};

function ModalBtn({ id, type = 'basic', title, icon, badge, children, onClick, onClose, hidden, disabled = false, className = '', ...props }) {
    const { isInGroup } = useContext(ButtonGroupContext);

    const ButtonComponent = BUTTON_COMPONENTS[type] || ButtonBasic; // Default to ButtonBasic

    function handleButtonClick(e) {
        if (e && e.stopPropagation) e.stopPropagation();
        dispatchCustomEvent('modal' + id, { eventKey: id });
        if (onClick) onClick(e);
    }

    // Determine final classes. If in group, add menu-item-reset
    const finalClassName = `${className} ${isInGroup ? 'menu-item-reset' : ''}`.trim();

    const buttonProps = {
        id: id || 'modal-btn',
        title: title,
        onClick: handleButtonClick,
        modalID: id,
        disabled: disabled,
        type: type, // Pass the type (e.g., 'pill-primary')
        className: finalClassName
    };

    if (type === 'basic' || type === undefined || type.startsWith('pill-')) {
        buttonProps.badge = badge || 0;
        buttonProps.icon = icon || '';
    } else if (type === 'topbar') {
        buttonProps.type = 'topbar';
    } else if (type === 'hub') {
        buttonProps.icon = icon;
    }

    const groupContext = useContext(ButtonGroupContext);

    return (
        <div hidden={hidden || false} className={isInGroup ? 'w-100' : ''}>
            <ButtonComponent {...buttonProps} />
            <Modal id={id} onClose={onClose} width="fit-content" style={{ maxWidth: '95vw', maxHeight: '95vh', ...props.style }}>
                <ButtonGroupContext.Provider value={{ ...groupContext, isInGroup: false }}>
                    {children}
                </ButtonGroupContext.Provider>
            </Modal>
        </div>
    );
}

export default ModalBtn;
